import { Controller } from "@hotwired/stimulus";

// Drives the reusable autocomplete: on input (debounced), sets the results turbo frame's src
// so the server returns HTML (Turbo Frame) and it replaces the results area.
export default class extends Controller {
  static values = {
    url: String,
    frameId: { type: String, default: "autocomplete_results" },
    param: { type: String, default: "q" },
    debounceMs: { type: Number, default: 200 },
    extraParams: { type: Object, default: {} },
  };

  static targets = ["input", "resultsFrame"];

  connect() {
    this.debounceTimer = null;
  }

  input() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(
      () => this.fetchResults(),
      this.debounceMsValue
    );
  }

  fetchResults() {
    if (!this.hasResultsFrameTarget || !this.urlValue) return;
    const q = this.hasInputTarget ? this.inputTarget.value.trim() : "";
    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set(this.paramValue, q);
    Object.entries(this.extraParamsValue).forEach(([key, val]) => {
      if (val != null && val !== "") url.searchParams.set(key, val);
    });
    this.resultsFrameTarget.src = url.toString();
  }

  clearResults() {
    if (this.hasResultsFrameTarget)
      this.resultsFrameTarget.removeAttribute("src");
  }
}
